import {API_ADMIN_URL} from "../../config/constants";
import { postRequest } from '../API'
/*********************************************************
* Function Name : list
* Description   : Get list of winners  
* By            : Afsar Ali
* Date          : 2025-08-20
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winners/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : list
* Description   : Get list of winners  
* By            : Afsar Ali
* Date          : 2025-08-20
*********************************************************/
export const checkWinner = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winners/check-winner`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : checkHourlyWinner
* Description   : Get list of winners  
*********************************************************/
export const checkHourlyWinner = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winners/check-hourly-winner`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : list
* Description   : Get list of winners  
* By            : Afsar Ali
* Date          : 2025-08-20
*********************************************************/
export const voucherList = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winners/voucher-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : createVoucher
* Description   : Get list of winners  
* By            : Afsar Ali
* Date          : 2025-08-20
*********************************************************/
export const createVoucher = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winners/generate-voucher2`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : createVoucher
* Description   : Get list of winners  
* By            : Afsar Ali
* Date          : 2025-08-22
*********************************************************/
export const deleteVoucher = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winners/delete-voucher`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : verifyVoucher
* Description   : Verify voucher  
* By            : Afsar Ali
* Date          : 08-12-2025
*********************************************************/
export const verifyVoucher = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winners/verify-voucher`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : assignVoucher
* Description   : Assign voucher  
* By            : Afsar Ali
* Date          : 08-12-2025
*********************************************************/
export const assignVoucher = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winners/assign-voucher`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : payoutVoucher
* By            : Afsar Ali
* Date          : 09-12-2025
*********************************************************/
export const payoutVoucher = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winners/voucher-complete-payout`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : list
* Description   : Get voucher details  
* By            : Afsar Ali
* Date          : 11-12-2025
*********************************************************/
export const voucherDetails = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winners/voucher-details`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function